module.exports = __webpack_public_path__ + "static/img/image_gs.e1350fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/image_gs.png
// module id = F4vp
// module chunks = 63